import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";

import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";

import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import SendIcon from "@material-ui/icons/Send";
import LockIcon from "@material-ui/icons/Lock";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useWebInfo } from "../../context/WebInfoContext";
import { getVersionText } from "../../config/version";

/* =========================
   COPYRIGHT (idéntico login)
========================= */
const Copyright = () => {
  const { webInfo } = useWebInfo();
  const companyName = webInfo?.companyName || "watoolx.com";

  return (
    <Typography variant="body2" align="center" style={{ color: "#64748b", fontSize: 13 }}>
      © {new Date().getFullYear()}{" "}
      <Link href="#" style={{ color: "#2563eb", fontWeight: 600 }}>
        {companyName}
      </Link>
      .
      <br />
      <span
        style={{
          marginTop: 6,
          display: "inline-block",
          background: "#0f172a",
          color: "#fff",
          padding: "4px 10px",
          borderRadius: 999,
          fontSize: 11,
          fontWeight: 700,
        }}
      >
        {getVersionText()}
      </span>
    </Typography>
  );
};

const useStyles = makeStyles((theme) => ({
  /* 🔒 ROOT EXACTO AL LOGIN (SIN ANIMACIONES) */
  root: {
    minHeight: "100vh",
    display: "grid",
    gridTemplateColumns: "1fr",
    background:
      "radial-gradient(1200px 500px at 20% 10%, rgba(59,130,246,0.18), transparent 60%)," +
      "radial-gradient(900px 400px at 80% 30%, rgba(16,185,129,0.12), transparent 55%)," +
      "linear-gradient(180deg, #f7f9ff 0%, #edf2ff 100%)",
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr",
    },
    overflowX: "hidden",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
  },

  /* Solo columna izquierda, centrada */
  leftOnly: {
    gridColumn: "1 / -1",
    display: "grid",
    placeItems: "center",
    padding: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(6),
    },
  },

  /* Tarjeta EXACTA al login */
  formPaper: {
    width: "100%",
    maxWidth: 460,
    borderRadius: 18,
    padding: theme.spacing(3),
    boxShadow: "0 18px 60px rgba(15, 23, 42, 0.10)",
    border: "1px solid rgba(15,23,42,0.06)",
    background: "rgba(255,255,255,0.92)",
    backdropFilter: "blur(10px)",
  },

  brandRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },

  logo: {
    width: 44,
    height: 44,
    borderRadius: 10,
    border: "1px solid rgba(15,23,42,0.08)",
    background: "#fff",
    objectFit: "cover",
  },

  companyName: {
    fontWeight: 900,
    color: "#0f172a",
    fontSize: 18,
  },

  title: {
    marginBottom: theme.spacing(1),
    fontSize: 26,
    fontWeight: 900,
    color: "#0f172a",
  },

  subtitle: {
    color: "rgba(15,23,42,0.65)",
    fontSize: 14,
    marginBottom: theme.spacing(2),
  },

  field: {
    marginBottom: 12,
    "& .MuiOutlinedInput-root": {
      minHeight: 46,
      borderRadius: 12,
      "& fieldset": { borderColor: "rgba(15,23,42,0.14)" },
      "&:hover fieldset": { borderColor: "rgba(15,23,42,0.25)" },
      "&.Mui-focused fieldset": { borderColor: "#2563eb" },
    },
  },

  submit: {
    marginTop: 10,
    height: 46,
    borderRadius: 12,
    fontWeight: 900,
    background: "linear-gradient(45deg, #2563eb 30%, #1d4ed8 90%)",
    color: "#fff",
    "& .MuiButton-startIcon": { color: "#fff" },
  },

  link: {
    color: "#2563eb",
    fontWeight: 800,
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  },

  footer: {
    marginTop: theme.spacing(2),
  },

  methodSelector: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: "rgba(15,23,42,0.02)",
    border: "1px solid rgba(15,23,42,0.08)",
  },

  methodLabel: {
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: theme.spacing(1),
  },

  radioGroup: {
    flexDirection: "row",
    justifyContent: "space-around",
  },

  radioLabel: {
    margin: 0,
    "& .MuiFormControlLabel-label": {
      fontSize: 14,
      fontWeight: 600,
      color: "rgba(15,23,42,0.7)",
    },
    "& .Mui-checked + .MuiFormControlLabel-label": {
      color: "#2563eb",
    },
  },
}));

const ForgetPassword = () => {
  const classes = useStyles();
  const { webInfo, loading } = useWebInfo();
  const [method, setMethod] = useState("whatsapp"); // "whatsapp" o "email"
  const [showResetForm, setShowResetForm] = useState(false); // Controla si mostrar formulario de restablecimiento
  const [userEmail, setUserEmail] = useState(""); // Email del usuario para restablecer
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;

  const [logo] = useState(
    () => `${backendUrl}/public/logotipos/login.png?r=${Date.now()}`
  );

  // Validación dinámica según el método seleccionado
  const getSchema = () => {
    if (method === "whatsapp") {
      return Yup.object({
        phone: Yup.string()
          .matches(/^[0-9]{10,15}$/, "Número inválido")
          .required("Número requerido"),
      });
    } else {
      return Yup.object({
        email: Yup.string()
          .email("Email inválido")
          .required("Email requerido"),
      });
    }
  };

  // Validación para el formulario de restablecimiento
  const resetSchema = Yup.object({
    token: Yup.string()
      .required("El código es obligatorio")
      .matches(/^\d{8}$/, "El código debe ser de 8 dígitos numéricos")
      .length(8, "El código debe tener exactamente 8 dígitos"),
    password: Yup.string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
        "La contraseña debe contener al menos una mayúscula, una minúscula y un número"
      )
      .required("La contraseña es obligatoria"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden")
      .required("Confirma tu contraseña"),
  });

  // Función para restablecer la contraseña
  const resetPassword = async (values) => {
    try {
      const url = `${backendUrl}/resetpasswords/${encodeURIComponent(userEmail)}/${encodeURIComponent(values.token)}/${encodeURIComponent(values.password)}`;
      
      const r = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const d = await r.json();

      if (r.ok && (!d.error && d.status !== 404 && d.status !== 500)) {
        toast.success("Contraseña restablecida exitosamente");
        setTimeout(() => (window.location.href = "/login"), 2000);
        return;
      }
      
      // Manejar diferentes tipos de errores
      let errorMessage = "Error al restablecer la contraseña";
      
      if (d.error) {
        errorMessage = d.error;
      } else if (d.message) {
        errorMessage = d.message;
      } else if (r.status === 404) {
        errorMessage = "Código inválido o expirado. Solicita un nuevo código.";
      } else if (r.status === 500) {
        errorMessage = "Error del servidor. Intenta nuevamente más tarde.";
      }
      
      toast.error(errorMessage);
    } catch (error) {
      toast.error("Error de conexión");
    }
  };

  const send = async (values) => {
    try {
      let url, successMessage;
      
      if (method === "whatsapp") {
        url = `${backendUrl}/forgetpassword/whatsapp/${values.phone}`;
        successMessage = "Contraseña enviada por WhatsApp";
      } else {
        url = `${backendUrl}/forgetpassword/${values.email}`;
        successMessage = "Email de recuperación enviado. Revisa tu bandeja de entrada.";
      }

      const r = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const d = await r.json();

      if (r.ok && d.status === 200) {
        toast.success(successMessage);
        
        // Si es WhatsApp, redirigir al login (ya se envía la contraseña directamente)
        if (method === "whatsapp") {
          setTimeout(() => (window.location.href = "/login"), 3000);
          return;
        }
        
        // Si es email, mostrar formulario para ingresar código y nueva contraseña
        if (method === "email") {
          setUserEmail(values.email);
          setShowResetForm(true);
          return;
        }
      }
      
      // Manejar errores específicos
      const errorMessage = d.message || "No se pudo enviar la solicitud";
      toast.error(errorMessage);
    } catch (error) {
      toast.error("Error de conexión");
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />

      <div className={classes.leftOnly}>
        <Paper className={classes.formPaper}>
          <div className={classes.brandRow}>
            <img src={logo} alt="logo" className={classes.logo} />
            <div className={classes.companyName}>
              {loading ? "Cargando..." : webInfo?.title || "Watoolx"}
            </div>
          </div>

          <Typography className={classes.title}>
            {showResetForm ? "Ingresa el código y nueva contraseña" : "Restablecer contraseña"}
          </Typography>
          <Typography className={classes.subtitle}>
            {showResetForm 
              ? `Ingresa el código que recibiste en ${userEmail} y tu nueva contraseña`
              : "Elige cómo quieres recuperar tu contraseña"}
          </Typography>

          {!showResetForm ? (
            <>
              <FormControl component="fieldset" className={classes.methodSelector}>
                <FormLabel component="legend" className={classes.methodLabel}>
                  Método de recuperación
                </FormLabel>
                <RadioGroup
                  className={classes.radioGroup}
                  value={method}
                  onChange={(e) => setMethod(e.target.value)}
                >
                  <FormControlLabel
                    value="whatsapp"
                    control={<Radio color="primary" />}
                    label="WhatsApp"
                    className={classes.radioLabel}
                  />
                  <FormControlLabel
                    value="email"
                    control={<Radio color="primary" />}
                    label="Correo electrónico"
                    className={classes.radioLabel}
                  />
                </RadioGroup>
              </FormControl>

              <Formik
                initialValues={{ phone: "", email: "" }}
                validationSchema={getSchema()}
                enableReinitialize
                onSubmit={send}
              >
                {({ isSubmitting }) => (
                  <Form>
                    {method === "whatsapp" ? (
                      <Field name="phone">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            fullWidth
                            variant="outlined"
                            label="WhatsApp registrado"
                            placeholder="Ej: 1234567890"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            className={classes.field}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <PhoneIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Field>
                    ) : (
                      <Field name="email">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            fullWidth
                            variant="outlined"
                            label="Correo electrónico registrado"
                            placeholder="Ej: usuario@ejemplo.com"
                            type="email"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            className={classes.field}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <EmailIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Field>
                    )}

                    <Button
                      type="submit"
                      fullWidth
                      className={classes.submit}
                      startIcon={<SendIcon />}
                      disabled={isSubmitting}
                    >
                      Enviar código
                    </Button>

                    <Box mt={2} textAlign="center">
                      <Link component={RouterLink} to="/login" className={classes.link}>
                        Volver al login
                      </Link>
                    </Box>

                    <Box className={classes.footer}>
                      <Copyright />
                    </Box>
                  </Form>
                )}
              </Formik>
            </>
          ) : (
            <Formik
              initialValues={{ token: "", password: "", confirmPassword: "" }}
              validationSchema={resetSchema}
              onSubmit={resetPassword}
            >
              {({ isSubmitting }) => (
                <Form>
                  <Field name="token">
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="outlined"
                        label="Código de verificación"
                        placeholder="Ingresa el código recibido"
                        error={meta.touched && Boolean(meta.error)}
                        helperText={meta.touched && meta.error}
                        className={classes.field}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <VpnKeyIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  </Field>

                  <Field name="password">
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="outlined"
                        label="Nueva contraseña"
                        type={showPassword ? "text" : "password"}
                        autoComplete="new-password"
                        error={meta.touched && Boolean(meta.error)}
                        helperText={meta.touched && meta.error}
                        className={classes.field}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  </Field>

                  <Field name="confirmPassword">
                    {({ field, meta }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="outlined"
                        label="Confirmar contraseña"
                        type={showConfirmPassword ? "text" : "password"}
                        autoComplete="new-password"
                        error={meta.touched && Boolean(meta.error)}
                        helperText={meta.touched && meta.error}
                        className={classes.field}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                edge="end"
                              >
                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  </Field>

                  <Button
                    type="submit"
                    fullWidth
                    className={classes.submit}
                    startIcon={<VpnKeyIcon />}
                    disabled={isSubmitting}
                  >
                    Restablecer contraseña
                  </Button>

                  <Box mt={2} textAlign="center">
                    <Link 
                      component="button" 
                      onClick={() => setShowResetForm(false)}
                      className={classes.link}
                      style={{ cursor: "pointer" }}
                    >
                      Volver atrás
                    </Link>
                  </Box>

                  <Box className={classes.footer}>
                    <Copyright />
                  </Box>
                </Form>
              )}
            </Formik>
          )}
        </Paper>
      </div>
    </div>
  );
};

export default ForgetPassword;
